<template>
  <g>
    <path
      d="M3 6.00018H16C16.55 6.00018 17 5.55018 17 5.00018C17 4.45018 16.55 4.00018 16 4.00018H3C2.45 4.00018 2 4.45018 2 5.00018C2 5.55018 2.45 6.00018 3 6.00018Z"
    />
    <path
      d="M15 17.0002H17V14.0002H17.18C17.81 14.0002 18.28 13.4202 18.16 12.8002L17.16 7.80018C17.07 7.34018 16.66 7.00018 16.18 7.00018H2.81995C2.33995 7.00018 1.92995 7.34018 1.83995 7.80018L0.839951 12.8002C0.719951 13.4202 1.18995 14.0002 1.81995 14.0002H1.99995V19.0002C1.99995 19.5502 2.44995 20.0002 2.99995 20.0002H9.99995C10.55 20.0002 11 19.5502 11 19.0002V14.0002H15V17.0002ZM8.99995 18.0002H3.99995V14.0002H8.99995V18.0002Z"
    />
    <path
      d="M22 18.0002H20V16.0002C20 15.4502 19.55 15.0002 19 15.0002C18.45 15.0002 18 15.4502 18 16.0002V18.0002H16C15.45 18.0002 15 18.4502 15 19.0002C15 19.5502 15.45 20.0002 16 20.0002H18V22.0002C18 22.5502 18.45 23.0002 19 23.0002C19.55 23.0002 20 22.5502 20 22.0002V20.0002H22C22.55 20.0002 23 19.5502 23 19.0002C23 18.4502 22.55 18.0002 22 18.0002Z"
    />
  </g>
</template>
